import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';
import {DateInterval, LogType} from '../swagger/models';
import {LogEditState} from '../views/log-edit/LogEditState';
import {Button} from './Button';
import {Card} from './Card';
import {FormCheckbox} from './form/FormCheckbox';
import {FormInput} from './form/FormInput';
import {FormSelect, FormSelectOption} from './form/FormSelect';

export interface CreateLogProps {
    state: LogEditState;
}

const intervals: FormSelectOption[] = [
    {
        key: '',
        label: 'None',
    },
    {
        key: DateInterval.Day,
        label: DateInterval.Day,
    },
    /*    {
            key: DateInterval.Month,
            label: DateInterval.Month,
        },*/
];

const logTypes: FormSelectOption[] = [
    {
        key: LogType.GenericJs,
        label: 'JavaScript / TypeScript Generic - for every website',
    },
    {
        key: LogType.AppJs,
        label: 'JavaScript / TypeScript App (Angular / React / React Native / Electron)',
    },
    {
        key: LogType.DotnetLog4Net,
        label: '.NET Log4Net',
    },
    {
        key: LogType.DotnetCoreMicrosoftExtensions,
        label: '.NET Core Microsoft Extensions',
    },
    {
        key: LogType.JavaLog4J,
        label: 'Java Log4J',
    },
    {
        key: LogType.JavaLogback,
        label: 'Java Logback',
    },
    {
        key: LogType.Php,
        label: 'PHP',
    },
    {
        key: LogType.WordPress,
        label: 'WordPress',
    },
    {
        key: LogType.UptimeCheck,
        label: 'Uptime check only',
    },
];

export const LogEditForm: FunctionComponent<CreateLogProps> = observer(({state}) =>
    <Card className="w-full xs:w-1/2"
          title={state.item.logId ? 'Edit log' : 'Add new log'}
    >
        <form onSubmit={(e) => e.preventDefault()}>
            <FormInput
                id="logname"
                invalid={!!state.errors.name}
                label="Log name"
                name="log-name"
                maxLength={20}
                onChange={(v) => state.setName(v)}
                required
                value={state.item.name}
            />
            <FormSelect
                help="Select correct for your system"
                id="logType"
                label="Language and framework"
                name="log-types"
                onChange={v => state.setLogType(v)}
                options={logTypes}
                required
                value={state.item.logType ?? LogType.GenericJs}
            />
            <br/>
            <FormInput
                help="You can enter here endpoint which will be checked every minute for HTTP status 200."
                id={'uptimeCheckUrl'}
                invalid={!!state.errors.uptimeCheckUrl}
                label={'Uptime check Url'}
                name="uptime-check"
                onChange={(v) => {
                    state.setUptimeCheckUrl(v);
                }}
                value={state.item.uptimeCheck?.uptimeCheckUrl}
            />
            <br/>
            <FormCheckbox
                checked={state.item.notifyOnNew ?? false}
                help="You will receive notification when new error is received"
                id="notifyOnNewOnly"
                label="Notify on new errors"
                name="new-errors-notification"
                onChange={v => state.setNotifyOnNew(v)}
            />
            <FormSelect
                help="Select how often you want to receive summary with errors on email"
                id="notifyInterval"
                label="Notification summary interval"
                name="notification-interval"
                onChange={v => state.setNotifyInterval(v)}
                options={intervals}
                value={state.item.notifyInterval}
            />
            <FormSelect
                help="You need to confirm email (you can view status in project settings), to receive notifications"
                id={'email'}
                label={'Notification Email'}
                name="notification-email"
                onChange={(v) => {
                    state.setNotificationEmail(v);
                }}
                options={state.projectUsers}
                value={state.item.notificationEmail ?? undefined}
            />
            <div className="grid grid-rows-1 grid-flow-col gap-4">
                <div>
                    <FormInput
                        help="If provided it will give access to https://app.muscula.com /api/public/list endpoint to get issues in json format "
                        id={'apiKey'}
                        inputmode="text"
                        label={'Api Key'}
                        name="notification-email"
                        readOnly={true}
                        placeholder="Press generate button"
                        onChange={(v) => {
                            state.setApiKey(v);
                        }}
                        type="text"
                        key={state.item.apiKey + ''}
                        value={state.item.apiKey}
                    />
                </div>
                <div>
                    <Button className="mt-7 btn btn-secondary" onClick={() => state.generateApiKey()}>Generate</Button>
                    <Button className="ml-2 mt-7 btn btn-secondary" onClick={() => state.copyApiKeyToClipBoard()}>Copy to clipboard</Button>
                </div>

            </div>

            {/*<FormInput
                help="You can create own endpoint to receive notifications about emails and pass it to internal systems, ie. own grafana, some dashboard"
                id={'webhookUrl'}
                inputmode='url'
                label={'Webhook'}
                name='webhook-url'
                onChange={(v) => state.setWebhookUrl(v)}
                type='url'
                value={state.item.webhookUrl}
            />*/}
            {/*<FormCheckbox
                checked={state.item.webhookNotifyEvery ?? false}
                help="If set, webhook will be called on every error, otherwise it will be called only on new ones"
                id="webhookNotifyEvery"
                label="Call webhook on every error"
                name='webhook-notification-frequency'
                onChange={v => state.setNotifyOnNew(v)}
            />*/}
            <Button className="btn btn-primary" onClick={() => state.save()}>{state.item.logId ? 'Save' : 'Create new log'}</Button>
        </form>
    </Card>,
);
